import React, { useContext, useState } from "react";
import { storeInformation } from "../../../contexts/StoreInformationContext";
import { StarIcon } from "@heroicons/react/solid";
import StarRatingComponent from "react-star-rating-component";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import paymentImage from "../../../assets/payment.jpg";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "font-awesome/css/font-awesome.min.css";
import Div from "../../../components/utils/Div";
import logo_demo from "../../../assets/demo_logo.png";
import { useTranslation } from "react-i18next";
import { domainProvider } from "../../../contexts/DomainContext";
import axios from "../../../components/utils/CustomerInterceptor";
import i18next from "i18next";

const StoreFooter = () => {
  const storeName = window.location.pathname.split("/")[1];
  const { storeDetails } = useContext(storeInformation);
  const { data } = storeDetails;
  const [reviewForm, setReviewForm] = useState(false);
  const customerInfo = JSON.parse(localStorage.getItem("customer"));
  const [rating, setRating] = useState(0);
  const [tempRating, setTempRating] = useState(0);
  const { t } = useTranslation();
  const selectLanguage = i18next.language;

  const { customdomain } = useContext(domainProvider);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const handleToReview = async (e) => {
    if (!customerInfo?.token) {
      toast.info("Please Login For write A review");
      return;
    }
    const reviewData = {
      ...e,
      rating,
    };
    const res = await axios.post(
      `${process.env.REACT_APP_APIURL}/vendor/store/customer/createreview`,
      JSON.stringify(reviewData),
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${customerInfo.token}`,
        },
      }
    );

    const response = await res.data;
    if (response.err) {
      toast.error(response.message);
      toast.error(response.err);
      return;
    }
    toast.success(response.message);
    setReviewForm(false);
  };

  const handleReview = () => {
    const cust_id = customerInfo?.data?.cust_id;
    const reviews = storeDetails?.data?.reviews;
    const find = reviews.find((review) => review.customer_id === cust_id);
    if (find) {
      return toast.info("You are already reviewed");
    }
    setReviewForm(true);
  };

  const handleLogout = async () => {
    const res2 = await axios.post(
      `${process.env.REACT_APP_APIURL}/vendor/store/customer/logout`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${customerInfo.token}`,
        },
      }
    );

    const response2 = await res2.data;
    if (response2.status_code !== 200) {
      return toast.error(response2.message);
    }
    toast.success(response2.message);
    localStorage.clear();
    window.location.reload();
  };

  return (
    <>
      <footer className=" bg-[#236260] pt-6 border-t border-green-300 mt-8">
        <Div>
          <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4 text-base-content py-12 font-domain">
            {/* Logo & Description */}
            <div className="text-center lg:text-left">
              <div className="flex justify-center lg:justify-start mb-4">
                <img
                  className="w-[100px]"
                  src={data?.storeDetails?.store_logo || logo_demo}
                  alt="company logo"
                />
              </div>
              <p className="mb-4 text-white text-sm">
                {(selectLanguage === "ar" && data?.storeDetails?.store_description_ar) ||
                  data?.storeDetails?.store_description ||
                  "Vendor Not added Store Description"}
              </p>
              <div className="flex justify-center lg:justify-start gap-4">
                {data?.socialMedias?.map((item, idx) => (
                  <a
                    key={idx}
                    target="_blank"
                    rel="noopener noreferrer"
                    href={item?.url}
                    className="text-xl text-white hover:text-green-600 transition-transform transform hover:scale-110"
                  >
                    <i className={item?.icon}></i>
                  </a>
                ))}
              </div>
            </div>

            {/* Shop Links */}
            <div className="text-center lg:text-left">
              <h4 className="text-white font-semibold mb-3">{t("Shop")}</h4>
              <ul className="space-y-2">
                <li>
                  <Link
                    to={`${customdomain === "aitech.com.sa"
                      ? `/${storeName}/user/profile`
                      : `/user/profile`
                      }`}
                    className="text-white hover:underline"
                  >
                    {t("My Account")}
                  </Link>
                </li>
                <li>
                  <Link
                    to={`${customdomain === "aitech.com.sa"
                      ? `/${storeName}/shop`
                      : `/shop`
                      }`}
                    className="text-white hover:underline"
                  >
                    {t("Shop")}
                  </Link>
                </li>
                {customerInfo?.token && (
                  <li
                    onClick={handleLogout}
                    className="text-white hover:underline cursor-pointer"
                  >
                    {t("Logout")}
                  </li>
                )}
              </ul>
            </div>

            {/* Support */}
            <div className="text-center lg:text-left">
              <h4 className="text-white font-semibold mb-3">{t("Support")}</h4>
              <ul className="space-y-2">
                <li>
                  <Link
                    to={`${customdomain === "aitech.com.sa"
                      ? `/${storeName}/contact_us`
                      : `/contact_us`
                      }`}
                    className="text-white hover:underline"
                  >
                    {t("HNav_contact")}
                  </Link>
                </li>
                <li>
                  <Link
                    to={`${customdomain === "aitech.com.sa"
                      ? `/${storeName}/track_order`
                      : `/track_order`
                      }`}
                    className="text-white hover:underline"
                  >
                    {t("Track")}
                  </Link>
                </li>
                <li>
                  <Link
                    to={`${customdomain === "aitech.com.sa"
                      ? `/${storeName}/track_order`
                      : `/track_order`
                      }`}
                    className="text-white hover:underline"
                  >
                    Privicy policy 
                  </Link>
                </li>
                <li>
                  <Link
                    to={`${customdomain === "aitech.com.sa"
                      ? `/${storeName}/track_order`
                      : `/track_order`
                      }`}
                    className="text-white hover:underline"
                  >
                    Terms and condition
                  </Link>
                </li>
              </ul>
            </div>

            {/* Contact Info */}
            <div className="text-center lg:text-left">
              <h4 className="text-white font-semibold mb-3">
                {t("HNav_contact")}
              </h4>
              <p className="text-sm text-white">{data?.storeDetails?.complete_address}</p>
              <p className="text-sm text-white">{data?.storeDetails?.store_phone}</p>
              <p className="text-sm text-white">{data?.storeDetails?.store_email}</p>
            </div>
          </div>
        </Div>

        {/* Bottom Bar */}
        <div className="bg-[#236260] border-t border-gray-200 py-3">
          <Div>
            <div className="flex flex-col sm:flex-row justify-between items-center px-5 text-sm text-white">
              <p className="mb-2 sm:mb-0">
                © 2024 <span className="font-semibold capitalize">{storeName}</span> | Made by AITECH
              </p>
              <img src={paymentImage} alt="payment methods" className="h-8 rounded" />
            </div>
          </Div>
        </div>
      </footer>

    </>
  );
};
export default StoreFooter;
